export default "__VITE_ASSET__CXl6YGF4__"